import { useState } from "react";
import { chooseMediaUrl } from "../lib/safeUrl.js";

export default function MediaFrame({ src, poster, alt, className = "" }) {
  const [failed, setFailed] = useState(false);
  const selected = chooseMediaUrl({ src, poster, failed });

  if (!selected) {
    return <div className={`media-fallback ${className}`} role="img" aria-label={alt} />;
  }

  return (
    <img
      className={className}
      src={selected}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
